// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"25d5f9c3","193":"657758ac","202":"da8f7186","264":"f11f0ce7","379":"97124229","467":"5131eb1a","557":"9c1e9b70","563":"619f43da","585":"bafb452d","595":"abdd64a1","596":"b5f5f621","722":"561eaec8","757":"923a6751","895":"82ddd34a","919":"4df5f9e5","970":"69115af7"}[chunkId] + ".chunk.js";
};